import { CommonModule } from '@angular/common';
import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DayOfWeekLabelPipe } from '@app/features/horaires/day-of-week-label-pipe';
import { ScheduleMonthlyDurationPipe } from '@app/features/horaires/schedule-monthly-duration-pipe';
import { ScheduleWeeklyDurationPipe } from '@app/features/horaires/schedule-weekly-duration-pipe';
import { SlotsDurationPipe } from '@app/features/horaires/slots-duration-pipe';
import { PeriodSalaryPipe } from '@app/features/salary/period-salary-pipe';
import { ColonToHPipe } from '@app/shared/colon-to-h-pipe';
import { LabelValue } from '@app/shared/forms/label-value/label-value';
import { ContractFormValue } from '../../embauche-tabs-form/contract-form/contract-form';
import { SchedulesFormValue } from '../../embauche-tabs-form/schedules-form/schedules-form';
import { HoursToDecimalPipe } from '../../../../horaires/hours-to-decimal-pipe';
import { DayOfWeek } from '@app/features/horaires/schedules.model';
import { slotsByDay } from '@app/features/horaires/slots-label';

@Component({
  standalone: true,
  selector: 'app-schedules-view',
  imports: [
    CommonModule,
    LabelValue,
    SlotsDurationPipe,
    ScheduleWeeklyDurationPipe,
    ScheduleMonthlyDurationPipe,
    MatTooltipModule,
    DayOfWeekLabelPipe,
    PeriodSalaryPipe,
    ColonToHPipe,
    HoursToDecimalPipe,
  ],
  templateUrl: './schedules-view.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./schedules-view.scss'],
})
export class SchedulesView {
  schedules = input.required<SchedulesFormValue>();
  contract = input.required<ContractFormValue>();
  /** Les horaires d'avant un avenant : ce qui en diffère est surligné (RG-avenant-consultation). */
  previous = input<SchedulesFormValue | null>(null);

  private readonly weeklyDuration = new ScheduleWeeklyDurationPipe();

  dayChange(day: DayOfWeek): string | null {
    const previous = this.previous();
    if (!previous) {
      return null;
    }
    const before = slotsByDay(previous.schedules)[day];
    return slotsByDay(this.schedules().schedules)[day] === before
      ? null
      : `Avant l'avenant : ${before}`;
  }

  weeklyChange(): string | null {
    const previous = this.previous();
    if (!previous) {
      return null;
    }
    const before = this.weeklyDuration.transform(previous.schedules);
    return this.weeklyDuration.transform(this.schedules().schedules) === before
      ? null
      : `Avant l'avenant : ${before} par semaine`;
  }
}
